import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download\"><path d=\"M192 604.48v224.032h640v-224h64v288H128v-288h64zM540.48 160v378.944h96l-128 158.048-128-158.08h96V160h64z\" fill=\"#d91d22\" p-id=\"4233\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol